export const isMplBlockedForCpc = (utmMedium?: string) => utmMedium?.toLowerCase() === 'cpc';
